var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Trash",
    transform: "translate(232.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-6",
    points: "-207.5,-205.1 -204.5,-205.1 -204.5,-181.1 -207.5,-181.1    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-7",
    points: "-201.5,-205.1 -198.5,-205.1 -198.5,-181.1 -201.5,-181.1    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-8",
    points: "-195.5,-205.1 -192.5,-205.1 -192.5,-181.1 -195.5,-181.1    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-9",
    points: "-219.5,-214.1 -180.5,-214.1 -180.5,-211.1 -219.5,-211.1    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-192.6-212.6h-2.8v-3c0-0.9-0.7-1.6-1.6-1.6h-6c-0.9,0-1.6,0.7-1.6,1.6v3h-2.8v-3     c0-2.4,2-4.4,4.4-4.4h6c2.4,0,4.4,2,4.4,4.4V-212.6",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-191-172.1h-18c-2.4,0-4.5-2-4.7-4.4l-2.8-36l3-0.2l2.8,36c0.1,0.9,0.9,1.6,1.7,1.6h18     c0.9,0,1.7-0.8,1.7-1.6l2.8-36l3,0.2l-2.8,36C-186.5-174-188.6-172.1-191-172.1",
    id: "Fill-11"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.462f2ffe522844ab7bc4d3c469d3bd17.svg";
export { ForwardRef as ReactComponent };